import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/businessSchoolApi'

class Store {
  id

  @action
  initId = value => {
    this.id = value
    this.getDetail(value)
  }

  @observable data = {}
  @action
  getDetail = async id => {
    let { success, data } = await Api.businessSchool({ id })
    if (success) {
      runInAction(() => {
        this.data = data || {}
      })
    }
  }
}
export default Store
